// extracted by mini-css-extract-plugin
export var logo = "_4z-2";
export var logoWrapper = "_4z-1";
export var strip = "_4z-0";